import React from "react";
import { ScrollView } from "react-native";
import WorkingTimeScheduleComponent from "../../../components/working_time/ScheduleWeekComponent";
import { DayOfWeek, DEFAULT_HOURS_PER_WEEK } from "../../../utils";
import {
    TimeMode,
    WorkingTimeScheduleType,
    ScheduleTimeType,
} from "../../../__generated__/graphql";
import type { Meta, StoryObj } from "@storybook/react";

const StoryComponent = () => {
    const [workingTime, setWorkingTime] = React.useState<WorkingTimeScheduleType>({
        [DayOfWeek.Monday]: {
            timeMode: TimeMode.Fixed,
            fixedTimes: [
                { startTime: 9 * 60, endTime: 12 * 60, type: ScheduleTimeType.Work },
                { startTime: 14 * 60, endTime: 17 * 60, type: ScheduleTimeType.Work },
            ],
        },
        [DayOfWeek.Tuesday]: {
            timeMode: TimeMode.Fixed,
            fixedTimes: [
                { startTime: 9 * 60, endTime: 12 * 60, type: ScheduleTimeType.Work },
                { startTime: 14 * 60, endTime: 17 * 60, type: ScheduleTimeType.Work },
            ],
        },
    });

    return (
        <ScrollView style={{ width: "100%", flex: 1 }}>
            <WorkingTimeScheduleComponent
                workingTime={workingTime}
                onChange={setWorkingTime}
                hoursPerWeek={DEFAULT_HOURS_PER_WEEK}
            />
        </ScrollView>
    );
};

const meta = {
    title: "Screens/Working time",
    component: StoryComponent,
    argTypes: {},
    decorators: [
        (StoryFn) => (
            <ScrollView>
                <StoryFn />
            </ScrollView>
        ),
    ],
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Scheduled: Story = {};
